
import { createSlice } from '@reduxjs/toolkit';

const CartSlice = createSlice({
    name: 'cart',
    initialState: {
        items: JSON.parse(localStorage.getItem('items')) || []
    },
    reducers: {
        addToCart : (state, action) =>{
            const existProduct = state.items.find((item) => item.id === action.payload.id)
            if(existProduct) {
                existProduct.quantity+=1
            } else {
                state.items.push({...action.payload,quantity:1})
            }
           
            localStorage.setItem('items', JSON.stringify(state.items))
        },
        updateToCart : (state, action) =>{
            const {product,qty} = action.payload;
            const existProduct = state.items.find((item) => item.id === product.id)
            if(existProduct) {
                existProduct.quantity= qty
            } else {
                state.items.push({...product,quantity:qty})
            }
           
            localStorage.setItem('items', JSON.stringify(state.items))
        },
        removeCart : (state, action) =>{
            const itemId = action.payload;
            state.items = state.items.filter(item => item.id !== itemId);
            localStorage.setItem('items', JSON.stringify(state.items));
        },
        incrementQuantity : (state,action) => {
            console.log('action :', action)
            const existProduct = state.items.find((item) => item.id === action.payload);
            console.log('existProduct :', existProduct)
            if(existProduct) {
                existProduct.quantity+=1
                localStorage.setItem('items', JSON.stringify(state.items))
            }
        },
        decrementQuantity : (state,action) => {
            const existProduct = state.items.find((item) => item.id === action.payload)
            if(existProduct && existProduct.quantity > 1) {
                existProduct.quantity-=1
                localStorage.setItem('items', JSON.stringify(state.items))
            }
        } 
    }
});

export const { addToCart, updateToCart, removeCart, incrementQuantity, decrementQuantity } = CartSlice.actions;
export default CartSlice.reducer;
